import styled from "@emotion/styled";
import { Container } from "@mantine/core";

export const FullContainer = styled(Container)`
  display: "flex";
  width: 100%;
  overflow: hidden;
`;
